import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import Loading from '../../../components/Loading';
import {
    addEmails,
    deleteEmail,
    getEmails,
} from '../../Settings/components/AdditionalEmailsSettings/query';
import isEmail from 'validator/lib/isEmail';
import { withTranslation } from 'react-i18next';

class AddAdditionalEmails extends Component {
    constructor() {
        super();

        this.handleChange = this.handleChange.bind(this);
        this.addUserFileds = this.addUserFileds.bind(this);
        this.deleteUserFileds = this.deleteUserFileds.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.getEmailsFn = this.getEmailsFn.bind(this);
        this.addInDeleteList = this.addInDeleteList.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.checkUsers = this.checkUsers.bind(this);
        this.isInvalid = this.isInvalid.bind(this);

        this.state = {
            updatedEmails: [{ id: uuid(), email: '', isValid: true }],
            emails: [],
            getLoader: false,
            deleteList: [],
        };
    }

    componentDidMount() {
        this.getEmailsFn();
    }

    async getEmailsFn() {
        try {
            this.setState({
                getLoader: true,
            });
            const res = await getEmails();
            const data = await res.json();
            if (res.status === 200) {
                const valuesWithIds = data.result.map((item) => ({
                    id: uuid(),
                    email: item,
                    isValid: true,
                }));
                this.setState({
                    getLoader: false,
                    emails: valuesWithIds,
                    updatedEmails: valuesWithIds?.length
                        ? valuesWithIds
                        : [{ id: uuid(), email: '' }],
                });
            } else {
                this.setState({
                    getLoader: false,
                });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    handleChange(e, id) {
        const updatedEmails = this.state.updatedEmails.map((user) => {
            if (user.id === id) {
                return {
                    ...user,
                    [e.target.name]: e.target.value,
                    isValid: e.target.value === '' ? true : isEmail(e.target.value),
                };
            }
            return user;
        });

        this.setState({
            updatedEmails,
        });
    }

    addUserFileds() {
        const emptyUser = {
            id: uuid(),
            email: '',
            isValid: true,
        };

        this.setState({
            updatedEmails: [...this.state.updatedEmails, emptyUser],
        });
    }

    deleteUserFileds(id, email) {
        this.addInDeleteList(email);
        this.setState({
            updatedEmails: this.state.updatedEmails.filter((item) => item.id !== id),
        });
    }

    addInDeleteList(email) {
        if (this.state.emails.find((item) => item.email === email)) {
            this.setState({
                deleteList: [...this.state.deleteList, email],
            });
        }
    }

    async onDelete(emails) {
        try {
            const res = await deleteEmail(emails);
            const data = await res.json();

            if (res.status === 200) {
                this.setState({
                    emails: this.state.emails.filter((item) => !emails.includes(item.email)),
                });
            } else {
                this.setState({
                    message: data?.message,
                });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    isInvalid() {
        const isInvalid = this.state.updatedEmails.find((item) => !item.isValid);

        this.setState({
            showErrors: !!isInvalid,
        });

        return !!isInvalid;
    }

    async onSubmit(save) {
        try {
            if (!save) return this.props.handleNext();
            if (this.isInvalid()) return;

            if (this.state.deleteList.length) {
                await this.onDelete(this.state.deleteList);
                this.setState({
                    deleteList: [],
                });
            }
            this.setState({
                loading: true,
            });

            const emails = this.state.updatedEmails
                .filter((item) => !this.state.emails.find((state) => state.email === item.email))
                .map((item) => item.email.trim())
                .filter((item, i, arr) => arr.indexOf(item) === i);

            const res = await addEmails(emails);
            if (res.status === 200) {
                this.setState({
                    loading: false,
                });
                this.getEmailsFn();
                this.props.handleNext();
            } else {
                const data = await res.json();
                this.setState({
                    loading: false,
                    message: data?.message ?? 'Something went wrong. Please try again.',
                    message_tags: 'error',
                });
            }
        } catch (err) {
            this.setState({
                loading: false,
                message: err.message ?? 'Something went wrong. Please try again.',
                message_tags: 'error',
            });
        }
    }

    checkUsers() {
        let emptyFields = 0;
        let filledFields = 0;
        this.state.updatedEmails.forEach((item) => {
            for (let key in item) {
                if (key === 'id' || key === 'isValid') continue;

                if (item[key]) {
                    filledFields += 1;
                    continue;
                }
                emptyFields += 1;
            }
        });

        if (!emptyFields && filledFields)
            return {
                save: true,
                disabled: false,
            };
        if (emptyFields && filledFields)
            return {
                save: true,
                disabled: true,
            };

        return {
            save: false,
            disabled: false,
        };
    }

    getName(save) {
        const { t } = this.props;
        if (save) return t('onboarding.save_and_next');
        return t('onboarding.skip');
    }

    render() {
        const { t } = this.props;
        const { save, disabled } = this.checkUsers();
        return (
            <>
                <div className="padding-x-20">
                    <div id="onboarding-general-settings">
                        {this.state.getLoader ? (
                            <Loading />
                        ) : (
                            this.state.updatedEmails.map((user, i, arr) => (
                                <div className="onboarding-add-user short" key={user.id}>
                                    <div className="onboarding-add-user-field">
                                        <label htmlFor="email" className="form-label">
                                            {t('onboarding.step_4.email_address')}
                                        </label>
                                        <input
                                            name="email"
                                            id="email"
                                            className="form-control"
                                            value={user.email}
                                            onChange={(e) => this.handleChange(e, user.id)}
                                        />
                                        {this.state.showErrors && !user.isValid && (
                                            <div className="error-message">
                                                {t('onboarding.step_4.email_address_error')}
                                            </div>
                                        )}
                                    </div>
                                    <div className="onboarding-add-user-btns">
                                        {arr.length !== 1 && (
                                            <button
                                                onClick={() =>
                                                    this.deleteUserFileds(user.id, user.email)
                                                }
                                            >
                                                -
                                            </button>
                                        )}
                                        {i === arr.length - 1 && (
                                            <button
                                                className="onboarding-add-user-btns-add"
                                                onClick={this.addUserFileds}
                                            >
                                                +
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))
                        )}
                        {this.state.message && (
                            <div className={`onboarding-message-${this.state.message_tags}`}>
                                {this.state.message}
                            </div>
                        )}
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer">
                    <button className="onboarding-skip-btn" onClick={() => this.props.handleBack()}>
                        {t('onboarding.back')}
                    </button>
                    <button
                        className="onboarding-btn-next"
                        onClick={() => this.onSubmit(save)}
                        disabled={this.state.loading || disabled}
                    >
                        {this.state.loading && <Loading onlyPreloader />}
                        {this.getName(save)}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(AddAdditionalEmails);
